import React from "react";
import { motion } from "framer-motion";
import {
  Box,
  Typography,
  Container,
  Avatar,
  Grid,
  Card,
  CardContent,
  Paper,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import logoMapache from "../img/logo_mapache.png"; // Asegúrate de tener el logo en esta ruta
import LicBustamante from "../img/LicLuisVargasBustamante.jpg"; // Asegúrate de tener el logo en esta ruta
import EquipoCE from "../img/ImagenCentro-Equipo.png"; // Asegúrate de tener el logo en esta ruta
import TikTokCard from "../Components/TikTokCard"; // Asegúrate de tener el componente TikTokCard
import TallerBecaEstipendio1 from "../img/TallerBecaEstipendio1.jpg";
import TallerBecaEstipendio2 from "../img/TallerBecaEstipendio2.jpg";
import TallerBecaEstipendioBanner from "../img/TallerBecaEstipendioBanner.jpg";
import Tupicenos from "../img/Tupicenos.png";
import FeriaProfesional1 from "../img/FeriaProfesional1.png";
import FeriaProfesional2 from "../img/FeriaProfesional2.png";
import JugueteUnaSonrisa from "../img/JugueteUnaSonrisa.png";
import JugueteUnaSonrisa2 from "../img/JugueteUnaSonrisa2.jpg";
import CampanaFrio from "../img/CampanaFrio.png";
import CenaSolidaria from "../img/CenaSolidaria.png";
import EllosTambienTienenHambre from "../img/EllosTambienTienenHambre.png";
import EleccionMissConta from "../img/EleccionMissConta.png";
import GanadoresCampeonato from "../img/GanadoresCampeonato.png";
import NinioJesus from "../img/NinioJesus.png";
import NinioJesusMisa from "../img/NinioJesusMisa.png";
import EquipoCE2 from "../img/ImagenCentro-Equipo2.png";
import AppPonderadosPues from "../img/AppPonderadosPues.png";
import ProyectoWifi from "../img/ProyectoWifi.png";
import ProyectoWifi_AccessPoint from "../img/ProyectoWifi_AccessPoint.png";
import ProyectoWifi_AccessPoint2 from "../img/ProyectoWifi_AccessPoint2.png";
import ProyectoWifiCodificado from "../img/ProyectoWifiCodificado.png";
import ProyectoWifiCodificado2 from "../img/ProyectoWifiCodificado2.png";

const CentroEstudiantes = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Detecta si es móvil
  // Datos de los miembros del equipo (puedes actualizar con fotos reales después)
  const miembros = [
    { nombre: "Miembro 2", puesto: "Cargo 2", imagen: logoMapache },
    { nombre: "Miembro 3", puesto: "Cargo 3", imagen: logoMapache },
    { nombre: "Miembro 4", puesto: "Cargo 4", imagen: logoMapache },
    { nombre: "Miembro 5", puesto: "Cargo 5", imagen: logoMapache },
    { nombre: "Miembro 6", puesto: "Cargo 6", imagen: logoMapache },
    { nombre: "Miembro 7", puesto: "Cargo 7", imagen: logoMapache },
    { nombre: "Miembro 8", puesto: "Cargo 8", imagen: logoMapache },
    { nombre: "Miembro 9", puesto: "Cargo 9", imagen: logoMapache },
    { nombre: "Miembro 10", puesto: "Cargo 10", imagen: logoMapache },
  ];

  // Ganadores del evento Miss
  const ganadores = [
    {
      titulo: "MISS CONTADURÍA",
      nombre: "Univ. Camila Alejandra Arroyo Condori",
    },
    {
      titulo: "SEÑORITA CONTADURÍA",
      nombre: "Univ. Katerine Mariel Quispe Mamani",
    },
    {
      titulo: "SEÑORITA REDES SOCIALES",
      nombre: "Univ. Daniela Ventura Berrios",
    },
    {
      titulo: "MÍSTER CONTADURÍA",
      nombre: "Univ. Bryan Darwin Quiroga Huarachi",
    },
  ];

  // Logros deportivos
  const logrosDeportivos = [
    "1er lugar Voleibol Damas",
    "1er lugar Voleibol Varones",
    "1er lugar Básquet Damas",
    "2do lugar Básquet Varones",
    "2do lugar Futsal Damas",
    "3er lugar Futsal Varones",
  ];

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.2 },
    }),
  };

  const cards = [
    {
      img: TallerBecaEstipendio1,
      alt: "Charla con estudiantes",
    },
    {
      img: TallerBecaEstipendio2,
      alt: "Afiche informativo Beca Comedor",
    },
    {
      img: TallerBecaEstipendioBanner,
      alt: "Estudiantes en orientación",
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      {/* Logo y Título Principal */}
      <Box textAlign="center">
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: "bold",
            color: "#5e35b1",
            textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
            mb: 2,
            px: 2,
            fontSize: {
              xs: "1.4rem",
              sm: "1.8rem",
              md: "2.2rem",
            },
          }}
        >
          Centro de Estudiantes del departamento de Contaduría Pública
          y Administración Financiera
        </Typography>

        {/* Logo */}
        <Box
          sx={{
            width: 90,
            height: 90,
            mx: "auto",
            mb: 1,
          }}
        >
          <img
            src={logoMapache}
            alt="Logo del Centro de Estudiantes - Mapache"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </Box>

        {/* Subtítulo */}
        <Typography
          variant="h5"
          sx={{ color: "#5e35b1", fontWeight: 600, mt: -1 }}
        >
          Conta P.U.E.S
        </Typography>
      </Box>

      <Paper
        sx={{
          p: 4,
          pt: 1,
          mb: 5,
          backgroundColor: "#f5f0ff",
          borderRadius: 3,
        }}
      >
        {/* Descripción General */}
        <motion.Box
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          sx={{
            width: "100%",
            maxWidth: 800,
            mx: "auto",
            my: 3,
            px: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Contenedor de la imagen con ancho condicional */}
          <Box
            sx={{
              width: isMobile ? "95%" : "60%", // ✅ 90% en móvil, 50% en desktop
              maxWidth: isMobile ? "100%" : 600,
              mx: "auto",
              position: "relative",
              overflow: "hidden",
              borderRadius: "14px",
              border: "2px solid #5e35b1",
              boxShadow: "0 6px 16px rgba(94, 53, 177, 0.18)",
              transition: "all 0.4s ease",
              "&:hover": {
                transform: isMobile
                  ? "scale(1)"
                  : "scale(1.05) rotate(1deg)", // Sin zoom en móvil
                boxShadow: isMobile
                  ? "0 6px 16px rgba(94, 53, 177, 0.18)"
                  : "0 12px 24px rgba(94, 53, 177, 0.3)",
              },
            }}
          >
            <img
              src={EquipoCE}
              alt="Miembros del Centro de Estudiantes"
              style={{
                width: "100%",
                height: "auto",
                display: "block",
                objectFit: "contain",
              }}
            />
          </Box>
        </motion.Box>
        <Typography
          variant="body1"
          paragraph
          textAlign="center"
          lineHeight={1.8}
        >
          El Centro de Estudiantes de Contaduría Pública y
          Administración Financiera “CONTA P.U.E.S.”, comprometidos
          con el desarrollo integral de sus estudiantes, continúa
          impulsando actividades de carácter académico, cultural,
          solidaria, social y deportiva. Fortaleciendo así el sentido
          de pertenencia y la identidad institucional dentro de
          nuestro querido departamento.
        </Typography>
      </Paper>

      {/* Actividades Académicas */}
      <Box mb={5}>
        <Typography
          variant="h5"
          component="h2"
          align="center"
          gutterBottom
          color="#5e35b1"
          fontWeight="600"
        >
          Actividades Académicas
        </Typography>

        {/* Primer bloque: Seminarios sobre normativa */}
        <Paper
          sx={{
            p: { xs: 1, sm: 2, md: 4 },
            backgroundColor: "#f8f9fa",
            borderRadius: 3,
            mb: 4,
          }}
        >
          <Typography
            variant="h5"
            align="center"
            fontWeight={600}
            color="primary"
            gutterBottom
          >
            Seminarios sobre Normativa Gubernamental
          </Typography>
          <Box
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            alignItems={isMobile ? "center" : "flex-start"}
            justifyContent="center"
            gap={3}
            sx={{
              px: { xs: 1, sm: 4, md: 8 },
              py: 2,
            }}
            textAlign={isMobile ? "center" : "left"}
          >
            {/* Texto */}
            <Box sx={{ order: isMobile ? 2 : 0 }}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: "0.9rem", sm: "1rem", md: "1rem" },
                }}
              >
                Se destacó la realización de seminarios sobre la{" "}
                <strong>
                  Ley 1178 “Ley de Administración y Control
                  Gubernamental”
                </strong>{" "}
                y el{" "}
                <strong>
                  Decreto Supremo 23318-A “Responsabilidad por la
                  Función Pública”
                </strong>
                , con el Lic. Aud. Luis Vargas Bustamante, ex servidor
                público de la Contraloría General del Estado -
                Cochabamba, como expositor. Ambas normativas son
                fundamentales en la formación de futuros contadores
                públicos autorizados y administradores financieros, ya
                que promueven principios de ética, transparencia y
                responsabilidad en la gestión pública. Estos espacios
                académicos fortalecen competencias clave para un
                desempeño profesional comprometido con el control y la
                rendición de cuentas.
              </Typography>
            </Box>

            {/* Imagen */}
            <Box
              sx={{
                width: { xs: 180, sm: 150 },
                height: { xs: 220, sm: 190 },
                flexShrink: 0,
                order: isMobile ? 1 : 0,
                boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
                borderRadius: "8px",
                overflow: "hidden",
                mt: -2,
              }}
            >
              <img
                src={LicBustamante}
                alt="Lic. Aud. Luis Vargas Bustamante - Expositor"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
          </Box>
          <Box
            display="flex"
            flexDirection={isMobile ? "column" : "column"}
            alignItems={isMobile ? "center" : "flex-start"}
            justifyContent="center"
            gap={2}
            sx={{
              px: { xs: 2, sm: 2, md: 8 },
            }}
            textAlign={isMobile ? "center" : "center"}
          >
            <Typography
              variant="h5"
              align="center"
              fontWeight={600}
              color="primary"
              gutterBottom
              mx="auto"
              display="block"
            >
              Orientación a la Beca Comedor 2025
            </Typography>
            {/* Texto */}
            <Box sx={{ order: isMobile ? 0 : 0 }}>
              <Typography
                variant="body1"
                align="left"
                sx={{
                  fontSize: { xs: "0.9rem", sm: "1rem", md: "1rem" },
                }}
              >
                Asimismo, se llevaron a cabo procesos de{" "}
                <strong>
                  orientación a la Beca Estipendio Socioeconómico
                </strong>
                , promoviendo el{" "}
                <strong>
                  acceso igualitario a oportunidades educativas
                </strong>{" "}
                para los estudiantes del departamento, fortaleciendo
                así la inclusión y el apoyo a quienes más lo
                necesitan. llevamos a cabo procesos de
                <strong>
                  orientación a la Beca Estipendio Socioeconómico.
                </strong>{" "}
                Estipendio Socioeconómico, con el objetivo de{" "}
                <strong>
                  {" "}
                  promover el acceso igualitario a oportunidades
                </strong>
                . Durante estas sesiones, se brindó apoyo específico a
                los universitarios, guiándolos paso a paso en la
                correcta presentación de la documentación requerida
                para acceder al beneficio, con un enfoque solidario
                hacia quienes atraviesan situaciones económicas
                adversas. Estas acciones fortalecen la inclusión y
                reafirman el compromiso institucional con el
                acompañamiento a los estudiantes que más lo necesitan,
                asegurando que puedan continuar sus estudios en
                condiciones más equitativas.
              </Typography>
            </Box>

            <Box
              sx={{
                py: 5,
                mx: "auto",
                backgroundColor: "#f4f6f8",
              }}
            >
              <Grid container spacing={3} justifyContent="center">
                {cards.map((card, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <motion.div
                      custom={index}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true }}
                      variants={cardVariants}
                    >
                      <Paper
                        elevation={3}
                        sx={{
                          borderRadius: 3,
                          overflow: "hidden",
                          transition: "transform 0.3s",
                          "&:hover": {
                            transform: "translateY(-6px)",
                          },
                        }}
                      >
                        <Box
                          component="img"
                          src={card.img}
                          alt={card.alt}
                          sx={{
                            width: "100%",
                            height: 220,
                            objectFit: "cover",
                          }}
                        />
                      </Paper>
                    </motion.div>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
        </Paper>
      </Box>

      {/* Feria Profesiográfica */}
      <Box mb={5}>
        <Typography
          variant="h5"
          component="h2"
          align="center"
          gutterBottom
          color="#5e35b1"
          fontWeight="600"
        >
          Feria Profesiográfica UTO
        </Typography>
        <Paper
          sx={{
            px: { xs: 1, sm: 4, md: 2 },
            py: 2,
            backgroundColor: "#e3f2fd",
            borderRadius: 3,
          }}
        >
          <Box
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            alignItems={isMobile ? "center" : "flex-start"}
            justifyContent="center"
            gap={3}
            sx={{
              px: { xs: 1, sm: 4, md: 6 },
              py: 2,
            }}
            textAlign={isMobile ? "center" : "left"}
          >
            <Box sx={{ order: isMobile ? 2 : 0 }}>
              <Typography variant="body1" paragraph>
                El Centro de Estudiantes del departamento de
                Contaduría Pública y Administración Financiera tuvo el
                honor de participar y colaborar en la{" "}
                <strong>
                  Feria Profesiográfica de la Universidad Técnica de
                  Oruro (UTO)
                </strong>
                , una actividad clave para la orientación vocacional
                de futuros bachilleres.
              </Typography>
              <Typography variant="body1" paragraph>
                una actividad clave para la orientación vocacional de
                los futuros bachilleres que buscan información sobre
                las distintas áreas del conocimiento que ofrece
                nuestra casa superior de estudios.
              </Typography>
              <Typography variant="body1" paragraph>
                Durante esta jornada, nuestro stand fue un punto de
                referencia para muchos estudiantes de secundaria que
                se acercaron con interés a conocer las oportunidades
                académicas, el perfil profesional y el campo laboral
                de nuestras carreras.
              </Typography>
            </Box>
            <Box
              sx={{
                width: { xs: 240, sm: "20%" },
                height: { xs: "auto", sm: "auto" },
                flexShrink: 0,
                order: isMobile ? 1 : 0,
                boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
                borderRadius: "8px",
                overflow: "hidden",
                mt: -2,
              }}
            >
              <img
                src={FeriaProfesional2}
                alt="Feria Profesiográfica UTO"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
          </Box>
          <Box
            display="flex"
            flexDirection={isMobile ? "column" : "column"}
            alignItems={isMobile ? "center" : "flex-start"}
            justifyContent="center"
            gap={3}
            sx={{
              px: { xs: 1, sm: 4, md: 8 },
              py: 2,
            }}
            textAlign={isMobile ? "center" : "left"}
          >
            <Box
              sx={{
                width: { xs: 300, sm: "70%" },
                height: { xs: 220, sm: 300 },
                boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
                borderRadius: "8px",
                overflow: "hidden",
                mt: -2,
                mx: "auto",
              }}
            >
              <img
                src={FeriaProfesional1}
                alt="Feria Profesiográfica UTO 2"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: isMobile ? "contain" : "cover",
                }}
              />
            </Box>
            <Box sx={{ order: isMobile ? 2 : 0 }}>
              <Typography variant="body1" paragraph>
                Con entusiasmo y compromiso, dimos a conocer el rol
                fundamental que cumplen los contadores públicos y
                administradores financieros en la economía nacional e
                internacional, destacando sus capacidades técnicas,
                éticas y analíticas para contribuir al desarrollo de
                organizaciones públicas y privadas.
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Box>

      {/* Actividades Culturales y Solidarias */}
      <Box mb={5}>
        <Typography
          variant="h5"
          component="h2"
          align="center"
          gutterBottom
          color="#5e35b1"
          fontWeight="600"
        >
          Actividades Culturales y Solidarias
        </Typography>
        <Paper
          sx={{
            px: { xs: 1, sm: 4, md: 6 },
            py: 2,
            backgroundColor: "#fff8e1",
            borderRadius: 3,
          }}
          align="center"
        >
          <Typography
            variant="h5"
            align="center"
            fontWeight={600}
            color="primary"
            gutterBottom
          >
            XXII Entrada Folklórica Cultural Universitaria
          </Typography>
          <Typography variant="body1" paragraph>
            Participamos en el{" "}
            <strong>
              “XXII Entrada Folklórica Cultural Universitaria 2024”
            </strong>{" "}
            con la danza tradicional de los <strong>Tupiceños</strong>
            , fortaleciendo la identidad cultural universitaria.
          </Typography>
          <Box
            sx={{
              width: { xs: "90%", sm: "55%" },
              height: { xs: "auti", sm: 190 },
              boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
              borderRadius: "8px",
              overflow: "hidden",
              mt: -2,
              mx: "auto",
            }}
          >
            <img
              src={Tupicenos}
              alt="Danza Tupiceños"
              style={{
                width: "100%",
                height: "100%",
                objectFit: isMobile ? "contain" : "cover",
              }}
            />
          </Box>
          <Typography
            variant="h5"
            align="center"
            fontWeight={600}
            color="primary"
            gutterBottom
            mt={2}
          >
            Campañas Solidarias
          </Typography>
          <Typography
            variant="body1"
            paragraph
            align="left"
            py={0}
            my={0}
          >
            Organizamos campañas solidarias como{" "}
            <strong>“Un juguete, una sonrisa”</strong>, entregando
            juguetes y chocolatada a niñas y niños en barrios
            periurbanos de Oruro durante la época navideña.
          </Typography>
          <Typography variant="body1" paragraph align="left" my={0}>
            También se llevó a cabo la{" "}
            <strong>“Campaña por el Frío”</strong>, distribuyendo
            chamarras, chompas y chalinas a personas necesitadas y en
            situación de calle.
          </Typography>
          <Typography variant="body1" paragraph align="left" my={0}>
            Celebramos el <strong>Día del Estudiante</strong>,
            ofreciendo salchipapas y refrescos gratuitas a todos los
            estudiantes del departamento, como muestra de integración
            y reconocimiento.
          </Typography>
          <Typography variant="body1" paragraph align="left" my={0}>
            Como parte de nuestro compromiso con la solidaridad,
            realizamos una actividad benéfica, entregando{" "}
            <strong>Cenas Solidaria</strong> a personas en situación
            de calle y escasos recursos en distintos puntos de la
            ciudad de Oruro.
          </Typography>
          <Typography variant="body1" paragraph align="left">
            Además, llevamos adelante la campaña{" "}
            <strong>“Porque ellos también sienten hambre”</strong>,
            una cruzada solidaria en la que recorrimos las zonas
            periurbanas de la ciudad de Oruro para entregar alimento a
            perros en situación de abandono. Esta iniciativa buscó
            brindar un gesto de cuidado y compasión hacia los animales
            que también sufren el frío y el hambre.
          </Typography>
          <Box
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            alignItems={isMobile ? "center" : "flex-start"}
            justifyContent={isMobile ? "center" : "flex-start"}
            gap={3}
            sx={{
              px: { xs: 1, sm: 4, md: 6 },
              py: 2,
            }}
            textAlign={isMobile ? "center" : "left"}
          >
            <Box
              sx={{
                width: { xs: "90%", sm: "35%" },
                height: { xs: "auti", sm: 270 },
                boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
                borderRadius: "8px",
                overflow: "hidden",
                mt: -2,
                mx: "auto",
              }}
            >
              <img
                src={JugueteUnaSonrisa}
                alt="un juguete, una sonrisa"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: isMobile ? "contain" : "cover",
                }}
              />
            </Box>
            <TikTokCard
              sxx={{
                width: { xs: "90%", sm: "35%" },
                height: { xs: "auti", sm: 270 },
                boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
                borderRadius: "8px",
                overflow: "hidden",
                mt: -2,
                mx: "auto",
              }}
              title="“Cena Solidaria”"
              tiktokUrl="https://vm.tiktok.com/ZMS74M6Kx/"
              image={CenaSolidaria}
            />

            <Box
              sx={{
                width: { xs: "90%", sm: "35%" },
                height: { xs: "auti", sm: 270 },
                boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
                borderRadius: "8px",
                overflow: "hidden",
                mt: -2,
                mx: "auto",
              }}
            >
              <img
                src={JugueteUnaSonrisa2}
                alt="un juguete, una sonrisa"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: isMobile ? "contain" : "cover",
                }}
              />
            </Box>
            <TikTokCard
              sxx={{
                width: { xs: "90%", sm: "35%" },
                height: { xs: "auti", sm: 270 },
                boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
                borderRadius: "8px",
                overflow: "hidden",
                mt: -2,
                mx: "auto",
              }}
              title="“Campaña por el Frío”"
              tiktokUrl="https://vm.tiktok.com/ZMS7CX6s9/"
              image={CampanaFrio}
            />
            <TikTokCard
              sxx={{
                width: { xs: "90%", sm: "35%" },
                height: { xs: "auti", sm: 270 },
                boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
                borderRadius: "8px",
                overflow: "hidden",
                mt: -2,
                mx: "auto",
              }}
              title="“Porque ellos también sienten hambre”"
              tiktokUrl="https://vm.tiktok.com/ZMS7X3Qvt/"
              image={EllosTambienTienenHambre}
            />
          </Box>
        </Paper>
      </Box>

      {/* Elección de Representantes */}
      <Box mb={5}>
        <Typography
          variant="h4"
          component="h2"
          align="center"
          gutterBottom
          color="#5e35b1"
          fontWeight="600"
        >
          Elección Miss y Míster Contaduría
        </Typography>
        <Paper
          sx={{ p: 4, backgroundColor: "#fce4ec", borderRadius: 3 }}
        >
          <Typography
            variant="body1"
            paragraph
            mb={3}
            textAlign="justify"
          >
            En lo social se realizó las elecciones de Miss, Señorita,
            Señorita Redes Sociales y Míster del departamento de
            Contaduría y Administración Financiera, un evento que no
            solo destaco la belleza y el carisma de nuestros
            compañeros, si no que también su capacidad para
            representar y promover los valores de nuestro departamento
          </Typography>
          <Box
            sx={{
              width: { xs: 300, sm: "70%" },
              height: { xs: 220, sm: 300 },
              boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
              borderRadius: "8px",
              overflow: "hidden",
              mt: -2,
              mb: 2,
              mx: "auto",
            }}
          >
            <img
              src={EleccionMissConta}
              alt="Elección de Miss Contaduría"
              style={{
                width: "100%",
                height: "100%",
                objectFit: isMobile ? "contain" : "cover",
              }}
            />
          </Box>
          <Grid container spacing={2}>
            {ganadores.map((ganador, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Box
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: "#fff",
                    borderLeft: "4px solid #d81b60",
                    textAlign: "left",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    color="#d81b60"
                  >
                    {ganador.titulo}
                  </Typography>
                  <Typography variant="body1">
                    {ganador.nombre}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Box>

      {/* Logros Deportivos */}
      <Box mb={5}>
        <Typography
          variant="h5"
          component="h2"
          align="center"
          gutterBottom
          color="#5e35b1"
          fontWeight="600"
        >
          Logros Deportivos
        </Typography>
        <Paper
          sx={{ p: 4, backgroundColor: "#e8f5e8", borderRadius: 3 }}
        >
          <Typography variant="body1" paragraph>
            En el ámbito <strong>deportivo</strong>, el departamento
            logró un destacado desempeño al consagrarse campeona de la
            Copa Rotatoria del{" "}
            <strong>“Campeonato Inter departamentos 2024”</strong>.
            Asimismo, se fortaleció a los equipos representativos de
            las selecciones correspondientes con{" "}
            <i>
              deportivos, mochilas, balones y equipamiento deportivo
            </i>{" "}
            para promover una vida saludable, el trabajo en equipo y
            el espíritu competitivo.
          </Typography>
          <Box
            display={"flex"}
            flexDirection={isMobile ? "column" : "row"}
            alignItems="center"
            justifyContent="between"
          >
            <List sx={{ order: isMobile ? 2 : 0 }}>
              <Typography variant="h6" component="h3">
                Campeones en las diferentes disciplinas:
              </Typography>
              {logrosDeportivos.map((logro, index) => (
                <ListItem key={index} sx={{ px: 0 }}>
                  <Box
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      backgroundColor: "#388e3c",
                      mr: 2,
                      mt: "8px",
                    }}
                  />
                  <ListItemText
                    primary={
                      <Typography variant="body1">
                        <strong>{logro}</strong>
                      </Typography>
                    }
                  />
                </ListItem>
              ))}
            </List>
            <Box
              sx={{
                width: { xs: 320, sm: "70%" },
                height: { xs: "auto", sm: 300 },
                boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
                borderRadius: "8px",
                overflow: "hidden",
                backgroundColor: "#0e510eff",
                mt: { xs: 0, sm: 1 },
                mb: 0,
                mx: "auto",
              }}
            >
              <img
                src={GanadoresCampeonato}
                alt="Elección de Miss Contaduría"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: isMobile ? "contain" : "cover",
                }}
              />
            </Box>
          </Box>
        </Paper>
      </Box>

      {/* Misa de Fin de Año */}
      <Box mb={5}>
        <Typography
          variant="h5"
          component="h2"
          align="center"
          gutterBottom
          color="#5e35b1"
          fontWeight="600"
        >
          Misa de Fin de Año
        </Typography>
        <Paper
          sx={{ p: 4, backgroundColor: "#f3e5f5", borderRadius: 3 }}
        >
          <Typography variant="body1" paragraph>
            Participamos en la misa tradicional de fin de año del
            Centro de Estudiantes, con la presencia del{" "}
            <strong>Lic. Augusto Vela Chacón</strong>, Decano de
            nuestra Facultad, como padrino del niñito de la gestión
            2024, y del compañero <strong>Erland Pérez Suazo</strong>,
            ex Ejecutivo Facultativo.
          </Typography>
          <Typography variant="body1" paragraph>
            Un momento de reflexión, agradecimiento y fortalecimiento
            comunitario.
          </Typography>
          <Box
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            alignItems={isMobile ? "center" : "flex-start"}
            justifyContent={isMobile ? "center" : "flex-start"}
            gap={3}
            sx={{
              px: { xs: 1, sm: 4, md: 6 },
              py: 2,
            }}
            textAlign={isMobile ? "center" : "left"}
          >
            <Box
              sx={{
                width: { xs: "90%", sm: "35%" },
                height: { xs: "auti", sm: 270 },
                boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
                borderRadius: "8px",
                overflow: "hidden",
                mt: -2,
                mx: "auto",
              }}
            >
              <img
                src={NinioJesus}
                alt="Niño Jesús"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: isMobile ? "contain" : "cover",
                }}
              />
            </Box>
            <Box
              sx={{
                width: { xs: "90%", sm: "45%" },
                height: { xs: "auti", sm: 270 },
                boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
                borderRadius: "8px",
                overflow: "hidden",
                mt: -2,
                mx: "auto",
              }}
            >
              <img
                src={NinioJesusMisa}
                alt="Niño jesus misa"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: isMobile ? "contain" : "cover",
                }}
              />
            </Box>
          </Box>
        </Paper>
      </Box>

      <Box mb={5}>
        <Typography
          variant="h5"
          component="h2"
          align="center"
          gutterBottom
          color="#5e35b1"
          fontWeight="600"
        >
          Implementación de Proyectos
        </Typography>

        <Paper
          sx={{
            px: { xs: 1, sm: 4, md: 2 },
            py: 2,
            backgroundColor: "#f5fbfeff",
            borderRadius: 3,
          }}
        >
          {/* Sección APP PUES */}
          <Box
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            alignItems="center"
            justifyContent="center"
            gap={3}
            sx={{
              px: { xs: 1, sm: 4, md: 6 },
              py: 2,
            }}
            textAlign={isMobile ? "justify" : "left"}
          >
            <Box sx={{ order: isMobile ? 2 : 0 }}>
              <Typography variant="body1" paragraph>
                En el marco del compromiso con la innovación y el
                apoyo académico a los estudiantes, se ha desarrollado
                una aplicación web denominada{" "}
                <strong>
                  "APP PUES – Calculadora de Puntos Ponderados"
                </strong>
                . Esta herramienta nace como respuesta a una necesidad
                frecuente entre los estudiantes para poder calcular de
                manera rápida y precisa sus puntos ponderados a partir
                de sus asistencias, prácticas, auxiliatura, parciales
                y examen final.
              </Typography>
              <Typography variant="body1" paragraph>
                El proceso de cálculo manual, que en muchas ocasiones
                genera confusión y errores, es reemplazado por una
                interfaz intuitiva, amigable y funcional.
              </Typography>
              <Typography variant="body1" color="primary">
                <a
                  href="https://conta-pues.web.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://conta-pues.web.app/
                </a>
              </Typography>
            </Box>
            <Box
              sx={{
                width: { xs: 300, sm: "35%" },
                height: { xs: "auto", sm: "auto" },
                flexShrink: 0,
                order: isMobile ? 1 : 0,
                boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <img
                src={AppPonderadosPues}
                alt="APP Conta Pues"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
          </Box>

          {/* Sección Proyecto Wifi */}
          <Box
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            alignItems="center"
            justifyContent="center"
            gap={3}
            sx={{
              px: { xs: 1, sm: 4, md: 6 },
              py: 1,
            }}
            textAlign={isMobile ? "justify" : "left"}
          >
            <Box
              sx={{
                width: { xs: 310, sm: "36%" },
                height: { xs: "auto", sm: "auto" },
                flexShrink: 0,
                boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <img
                src={ProyectoWifi}
                alt="Proyecto Wifi"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
            <Box>
              <Typography variant="body1" paragraph>
                En lo referido a infraestructura tecnológica, se
                gestionó el Proyecto de Conectividad:{" "}
                <strong>Implementación de Red Wifi Gratuita</strong>{" "}
                para Estudiantes de Contaduría Pública y
                Administración Financiera.
              </Typography>
              <Typography variant="body1" paragraph>
                Esta iniciativa tiene como objetivo garantizar el
                acceso a internet de calidad a los estudiantes,
                permitiéndoles conectarse a plataformas educativas,
                acceder a bibliografía digital y realizar
                investigaciones en línea de forma eficiente.
              </Typography>
              <Typography variant="body1" paragraph>
                Beneficiarios del proyecto: 13 cursos de Contaduría
                Pública y Administración Financiera: <br />
                <strong>Contaduría Pública:</strong> 3V1, 3V2, 3V3,
                4D1, 4D2, 4D3, 4V1, 4V2, 5D1, 5D2, 5V1, 5V2 <br />
                <strong>Administración Financiera:</strong> 4D1
              </Typography>
            </Box>
          </Box>

          {/* Equipamiento y Control */}
          <Box sx={{ px: { xs: 2, sm: 4, md: 6 }, py: 1 }}>
            <Box
              display="flex"
              flexDirection={isMobile ? "column" : "row"}
              alignItems={isMobile ? "center" : "flex-start"}
              justifyContent={isMobile ? "center" : "flex-start"}
              gap={3}
              sx={{
                px: { xs: 1, sm: 4 },
              }}
            >
              <Box>
                <Typography
                  variant="body1"
                  paragraph
                  fontWeight={600}
                >
                  Para llevar a cabo este proyecto, se adquirió
                  equipamiento de alta calidad:
                </Typography>
                <Typography
                  variant="body2"
                  component="ul"
                  sx={{ pl: 2 }}
                >
                  <li>
                    4x Access Point UNIFI 6 LR – Dual band 2.4/5GHz,
                    MIMO 4x4
                  </li>
                  <li>
                    2x Access Point UNIFI AC LITE – Dual band
                    2.4/5GHz, MIMO 2x2
                  </li>
                  <li>2x Bobinas de cable UTP Cat5e (305m)</li>
                  <li>1x Switch Cloud Router (24 puertos)</li>
                  <li>1x Gabinete SOHO</li>
                  <li>Soporte de instalación y configuración</li>
                </Typography>
                <Typography variant="body2" fontWeight="bold" mt={2}>
                  Total inversión: Bs 31.729.-
                </Typography>
              </Box>
              <Box
                display="flex"
                flexDirection={isMobile ? "column" : "row"}
                alignItems={isMobile ? "center" : "flex-start"}
                justifyContent={isMobile ? "center" : "flex-start"}
                textAlign={isMobile ? "center" : "left"}
              >
                <Box
                  sx={{
                    width: { xs: "90%", sm: "45%" },
                    height: { xs: "auto", sm: 240 },
                    boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
                    borderRadius: "8px",
                    overflow: "hidden",
                    mx: "auto",
                    mb: { xs: 2, sm: 0 },
                  }}
                >
                  <img
                    src={ProyectoWifi_AccessPoint}
                    alt="Proyecto Wifi Access Point"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: isMobile ? "contain" : "cover",
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    width: { xs: "90%", sm: "45%" },
                    height: { xs: "auto", sm: 240 },
                    boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
                    borderRadius: "8px",
                    overflow: "hidden",
                    mx: "auto",
                  }}
                >
                  <img
                    src={ProyectoWifi_AccessPoint2}
                    alt="Proyecto Wifi Access Point 2"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: isMobile ? "contain" : "cover",
                    }}
                  />
                </Box>
              </Box>
            </Box>
            <Typography variant="body1" paragraph mt={3}>
              Con el objetivo de asegurar la transparencia y el
              adecuado control del patrimonio adquirido, se informa
              que los equipos principales ya han sido registrados con
              sus respectivos códigos como activos oficiales del
              Centro de Estudiantes. Esta codificación garantiza su
              trazabilidad y resguardo institucional, asegurando su
              uso exclusivo para fines académicos.
            </Typography>
            <Box
              display="flex"
              flexDirection={isMobile ? "column" : "row"}
              alignItems={isMobile ? "center" : "flex-start"}
              justifyContent={isMobile ? "center" : "flex-start"}
              gap={3}
              sx={{
                px: { xs: 1, sm: 4, md: 6 },
                py: 2,
              }}
              textAlign={isMobile ? "center" : "left"}
            >
              <Box
                sx={{
                  width: { xs: "90%", sm: "35%" },
                  height: { xs: "auti", sm: 300 },
                  boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
                  borderRadius: "8px",
                  overflow: "hidden",
                  mt: -2,
                  mx: "auto",
                }}
              >
                <img
                  src={ProyectoWifiCodificado}
                  alt="Proyecto Wifi Codificado"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: isMobile ? "contain" : "cover",
                  }}
                />
              </Box>
              <Box
                sx={{
                  width: { xs: "90%", sm: "35%" },
                  height: { xs: "auti", sm: 300 },
                  boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
                  borderRadius: "8px",
                  overflow: "hidden",
                  mt: -2,
                  mx: "auto",
                }}
              >
                <img
                  src={ProyectoWifiCodificado2}
                  alt="Proyecto Wifi Codificado 2"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: isMobile ? "contain" : "cover",
                  }}
                />
              </Box>
            </Box>
            <Typography variant="body1" paragraph>
              Este proyecto marca un hito importante en la mejora de
              las condiciones tecnológicas de nuestras aulas y
              refuerza el compromiso del Centro de Estudiantes con el
              bienestar académico de toda la comunidad universitaria.
              Continuaremos trabajando para que la tecnología y el
              acceso a la información estén al alcance de todos.
            </Typography>
          </Box>
        </Paper>
      </Box>

      {/* Mensaje Final */}
      <Paper
        sx={{
          p: 5,
          textAlign: "center",
          borderRadius: 4,
          backgroundColor: "#1a3a6e",
          color: "#fff",
          mb: 5,
        }}
      >
        <Typography
          variant="h5"
          fontWeight="500"
          mb={2}
          component="h3"
        >
          Compromiso, Unidad y Progreso: El Rol del Centro de
          Estudiantes de Contaduría Pública y Administración
          Financiera
        </Typography>
        <Box
          sx={{
            width: { xs: 300, sm: "70%" },
            height: { xs: 220, sm: 300 },
            boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
            borderRadius: "8px",
            overflow: "hidden",
            mt: { xs: -4, sm: 0 },
            mb: { xs: -2, sm: 2 },
            mx: "auto",
          }}
        >
          <img
            src={EquipoCE2}
            alt="Equipo del Centro de Estudiantes"
            style={{
              width: "100%",
              height: "100%",
              objectFit: isMobile ? "contain" : "cover",
            }}
          />
        </Box>
        <Typography
          variant="body1"
          color="rgba(255,255,255,0.9)"
          align="justify"
        >
          El trabajo del Centro de Estudiantes{" "}
          <strong>“CONTA P.U.E.S.”</strong>
          refleja el compromiso con una gestión participativa,
          transparente y cercana a las verdaderas necesidades de los
          estudiantes. Las acciones desarrolladas no solo fortalecen
          la formación profesional, sino que también consolidan un
          entorno universitario más humano, solidario y activo.
        </Typography>

        <Typography
          variant="subtitle1"
          textAlign="center"
          mt={3}
          fontWeight="bold"
        >
          UNIV. KEVIN REYNAGA CONDORI
        </Typography>
        <Typography
          variant="subtitle2"
          textAlign="center"
          display="block"
        >
          STRIO. EJECUTIVO DEL C.E. DEL DPTO. DE CONTADURÍA PÚBLICA Y
          ADMINISTRACIÓN FINANCIERA DE LA F.C.E.F.A.
        </Typography>
        <Typography variant="body3">Gestión 2024 - 2026</Typography>
      </Paper>

      {/* Footer */}
      <Box
        textAlign="center"
        mt={8}
        pt={3}
        borderTop="1px solid #ddd"
      >
        <Typography variant="body2" color="textSecondary">
          © 2024 Centro de Estudiantes “CONTA P.U.E.S.” – FCEFA, UTO
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Impulsando el desarrollo integral desde la Contaduría
          Pública y Administración Financiera
        </Typography>
      </Box>
    </Container>
  );
};

export default CentroEstudiantes;
